import type { ComponentStyleConfig } from "@chakra-ui/theme";
import { textStyles } from "theme/text-styles";

export const Tooltip: ComponentStyleConfig = {
  baseStyle: {
    "--tooltip-bg": "var(--chakra-colors-brand-background-dark)",
    borderRadius: "tiny",
    bg: "brand.background.dark",
    dropShadow: "0px 0px 6px rgba(0, 0, 0, 0.30)",
    maxW: "260px",
    p: "smallest",
    ...textStyles.caption2,
  },
};
